import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, where, orderBy } from 'firebase/firestore';
import { db } from '../firebase/config';

const COULEUR = '#1C2833';
const ROUGE = '#C0392B';

export default function HistoriqueActions({ onClose }) {
  const [actions, setActions] = useState([]);
  const [commerciaux, setCommerciaux] = useState([]);
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  // Filtres
  const [filtreStatut, setFiltreStatut] = useState('Tous');
  const [filtreEnRetard, setFiltreEnRetard] = useState(false);
  const [filtreComm, setFiltreComm] = useState('Tous');
  const [filtreClient, setFiltreClient] = useState('');
  const [filtreDateDebut, setFiltreDateDebut] = useState('');
  const [filtreDateFin, setFiltreDateFin] = useState('');
  const [showFiltres, setShowFiltres] = useState(false);
  const [triDate, setTriDate] = useState('desc'); // desc = plus recent en premier

  useEffect(() => { charger(); }, []);

  const charger = async () => {
    setLoading(true);
    try {
      const aSnap = await getDocs(collection(db, 'actions'));
      setActions(aSnap.docs.map(d => ({ id: d.id, ...d.data() })));

      const uSnap = await getDocs(query(collection(db, 'users'), where('role', '==', 'commercial')));
      setCommerciaux(uSnap.docs.map(d => ({ id: d.id, ...d.data() })));

      const cSnap = await getDocs(collection(db, 'clients'));
      setClients(cSnap.docs.map(d => ({ id: d.id, ...d.data() })));
    } catch (e) { console.log(e); }
    setLoading(false);
  };

  const getNomComm = (id) => {
    const c = commerciaux.find(x => x.id === id);
    return c ? `${c.prenom} ${c.nom}` : id;
  };

  const resetFiltres = () => {
    setFiltreStatut('Tous');
    setFiltreEnRetard(false);
    setFiltreComm('Tous');
    setFiltreClient('');
    setFiltreDateDebut('');
    setFiltreDateFin('');
  };

  const aujourdhui = new Date().toISOString().split('T')[0];
  const actionsFiltrees = actions.filter(a => {
    const enRetard = a.statut === 'A FAIRE' && a.dateAction && a.dateAction < aujourdhui;
    if (filtreEnRetard) return enRetard;
    const matchStatut = filtreStatut === 'Tous' || (filtreStatut === 'A FAIRE' ? (a.statut === 'A FAIRE' && (!a.dateAction || a.dateAction >= aujourdhui)) : a.statut === filtreStatut);
    const matchComm = filtreComm === 'Tous' || a.commercialId === filtreComm;
    const matchClient = !filtreClient || a.clientNom?.toLowerCase().includes(filtreClient.toLowerCase());
    const matchDateDebut = !filtreDateDebut || (a.dateAction && a.dateAction >= filtreDateDebut);
    const matchDateFin = !filtreDateFin || (a.dateAction && a.dateAction <= filtreDateFin);
    return matchStatut && matchComm && matchClient && matchDateDebut && matchDateFin;
  }).sort((a, b) => {
    const da = a.dateAction || '';
    const db2 = b.dateAction || '';
    return triDate === 'desc' ? db2.localeCompare(da) : da.localeCompare(db2);
  });

  const nbFiltresActifs = [
    filtreStatut !== 'Tous',
    filtreComm !== 'Tous',
    filtreClient !== '',
    filtreDateDebut !== '',
    filtreDateFin !== '',
  ].filter(Boolean).length;

  const statutStyle = (statut, dateAction) => {
    if (statut === 'FAIT') return { bg: '#EAF3DE', color: '#3B6D11', label: 'Fait' };
    if (statut === 'ANNULE') return { bg: '#f5f5f5', color: '#888', label: 'Annule' };
    const enRetard = dateAction && dateAction < new Date().toISOString().split('T')[0];
    if (enRetard) return { bg: '#FCEBEB', color: ROUGE, label: 'En retard' };
    return { bg: '#FAEEDA', color: '#854F0B', label: 'A faire' };
  };

  return (
    <div style={styles.app}>
      <div style={styles.topbar}>
        <button onClick={onClose} style={styles.backBtn}>←</button>
        <div style={{ flex: 1 }}>
          <div style={styles.topbarTitle}>Historique Actions</div>
          <div style={styles.topbarSub}>{actionsFiltrees.length} action(s)</div>
        </div>
        <button style={{ background: 'rgba(255,255,255,0.15)', border: 'none', borderRadius: 8, color: '#fff', fontSize: 11, fontWeight: 600, padding: '6px 8px', cursor: 'pointer', flexShrink: 0 }}
          onClick={() => setTriDate(t => t === 'desc' ? 'asc' : 'desc')}>
          {triDate === 'desc' ? '↓ Date' : '↑ Date'}
        </button>
        <button style={{ ...styles.filtreToggleBtn, background: showFiltres ? 'rgba(255,255,255,0.3)' : 'rgba(255,255,255,0.15)' }}
          onClick={() => setShowFiltres(f => !f)}>
          Filtres {nbFiltresActifs > 0 ? `(${nbFiltresActifs})` : ''}
        </button>
      </div>

      {/* FILTRES */}
      {showFiltres && (
        <div style={styles.filtresPanel}>
          <div style={styles.filtreRow}>
            <div style={styles.filtreLabel}>Statut</div>
            <select style={styles.select} value={filtreStatut} onChange={e => setFiltreStatut(e.target.value)}>
              <option value="Tous">Tous</option>
              <option value="A FAIRE">A faire</option>
              <option value="FAIT">Fait</option>
              <option value="ANNULE">Annule</option>
            </select>
          </div>
          <div style={styles.filtreRow}>
            <div style={styles.filtreLabel}>Commercial</div>
            <select style={styles.select} value={filtreComm} onChange={e => setFiltreComm(e.target.value)}>
              <option value="Tous">Tous</option>
              {commerciaux.map(c => <option key={c.id} value={c.id}>{c.prenom} {c.nom}</option>)}
            </select>
          </div>
          <div style={styles.filtreRow}>
            <div style={styles.filtreLabel}>Client</div>
            <input style={styles.filtreInput} placeholder="Nom du client..."
              value={filtreClient} onChange={e => setFiltreClient(e.target.value)} />
          </div>
          <div style={styles.filtreRow}>
            <div style={styles.filtreLabel}>Du</div>
            <input type="date" style={styles.filtreInput}
              value={filtreDateDebut} onChange={e => setFiltreDateDebut(e.target.value)} />
          </div>
          <div style={styles.filtreRow}>
            <div style={styles.filtreLabel}>Au</div>
            <input type="date" style={styles.filtreInput}
              value={filtreDateFin} onChange={e => setFiltreDateFin(e.target.value)} />
          </div>
          {nbFiltresActifs > 0 && (
            <button style={styles.resetBtn} onClick={resetFiltres}>Reinitialiser les filtres</button>
          )}
        </div>
      )}

      {/* STATS RAPIDES */}
      <div style={styles.statsBar}>
        {[
          { label: 'A faire', count: actions.filter(a => a.statut === 'A FAIRE' && (!a.dateAction || a.dateAction >= new Date().toISOString().split('T')[0])).length, color: '#854F0B', bg: '#FAEEDA' },
          { label: 'En retard', count: actions.filter(a => a.statut === 'A FAIRE' && a.dateAction && a.dateAction < new Date().toISOString().split('T')[0]).length, color: ROUGE, bg: '#FCEBEB' },
          { label: 'Faites', count: actions.filter(a => a.statut === 'FAIT').length, color: '#3B6D11', bg: '#EAF3DE' },
          { label: 'Annulees', count: actions.filter(a => a.statut === 'ANNULE').length, color: '#888', bg: '#f5f5f5' },
        ].map((s, i) => (
          <div key={i} style={{ ...styles.statPill, background: s.bg, cursor: 'pointer' }}
            onClick={() => {
              if (s.label === 'En retard') {
                setFiltreEnRetard(true);
                setFiltreStatut('Tous');
              } else {
                setFiltreEnRetard(false);
                setFiltreStatut(s.label === 'A faire' ? 'A FAIRE' : s.label === 'Faites' ? 'FAIT' : 'ANNULE');
              }
            }}>
            <div style={{ fontSize: 16, fontWeight: 700, color: s.color }}>{s.count}</div>
            <div style={{ fontSize: 10, color: s.color }}>{s.label}</div>
          </div>
        ))}
      </div>

      {/* LISTE */}
      <div style={styles.listWrap}>
        {loading && <div style={styles.empty}>Chargement...</div>}
        {!loading && actionsFiltrees.length === 0 && (
          <div style={styles.empty}>
            <div style={{ fontSize: 32 }}>✅</div>
            <div>Aucune action trouvee</div>
            {nbFiltresActifs > 0 && (
              <button style={styles.resetBtn2} onClick={resetFiltres}>Reinitialiser les filtres</button>
            )}
          </div>
        )}

        {actionsFiltrees.map(a => {
          const st = statutStyle(a.statut, a.dateAction);
          return (
            <div key={a.id} style={styles.actionCard}>
              <div style={styles.actionHeader}>
                <div style={{ flex: 1 }}>
                  <div style={styles.actionTitre}>{a.action}</div>
                  <div style={styles.actionClient}>{a.clientNom}</div>
                </div>
                <div style={{ ...styles.statutBadge, background: st.bg, color: st.color }}>
                  {st.label}
                </div>
              </div>

              <div style={styles.actionMeta}>
                {a.dateAction && (
                  <span style={styles.metaItem}>
                    📅 {new Date(a.dateAction + 'T12:00:00').toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', year: 'numeric' })}
                  </span>
                )}
                {a.commercialId && (
                  <span style={styles.metaItem}>👤 {getNomComm(a.commercialId)}</span>
                )}
                {a.responsable && (
                  <span style={styles.metaItem}>→ {a.responsable}</span>
                )}
              </div>

              {a.commentaireCloture && (
                <div style={styles.commentaire}>
                  💬 {a.commentaireCloture}
                </div>
              )}

              {a.dateCloture && (
                <div style={{ fontSize: 10, color: '#aaa', marginTop: 4 }}>
                  Cloturee le {new Date(a.dateCloture).toLocaleDateString('fr-FR')}
                </div>
              )}

              {a.reporteeDepuis && (
                <div style={{ fontSize: 10, color: '#888', marginTop: 4 }}>
                  Reportee depuis une action precedente
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

const styles = {
  app: { maxWidth: 480, margin: '0 auto', minHeight: '100vh', background: '#f5f5f5', display: 'flex', flexDirection: 'column', fontFamily: 'system-ui, sans-serif' },
  topbar: { background: COULEUR, padding: '1rem 1.25rem', color: '#fff', display: 'flex', alignItems: 'center', gap: 10 },
  backBtn: { background: 'rgba(255,255,255,0.15)', border: 'none', borderRadius: '50%', width: 32, height: 32, color: '#fff', fontSize: 16, cursor: 'pointer', flexShrink: 0 },
  topbarTitle: { fontSize: 15, fontWeight: 600 },
  topbarSub: { fontSize: 11, opacity: 0.7, marginTop: 2 },
  filtreToggleBtn: { border: 'none', borderRadius: 8, color: '#fff', fontSize: 11, fontWeight: 600, padding: '6px 10px', cursor: 'pointer', flexShrink: 0 },
  filtresPanel: { background: '#fff', borderBottom: '1px solid #eee', padding: '10px 12px', display: 'flex', flexDirection: 'column', gap: 8 },
  filtreRow: { display: 'flex', alignItems: 'center', gap: 10 },
  filtreLabel: { fontSize: 12, color: '#666', width: 70, flexShrink: 0 },
  select: { flex: 1, padding: '7px 8px', border: '1px solid #ddd', borderRadius: 8, background: '#f9f9f9', fontSize: 12, color: '#444' },
  filtreInput: { flex: 1, padding: '7px 10px', border: '1px solid #ddd', borderRadius: 8, fontSize: 12, fontFamily: 'system-ui' },
  resetBtn: { padding: '8px', border: '1px solid #F5C6C6', borderRadius: 8, background: '#FCEBEB', color: ROUGE, fontSize: 12, cursor: 'pointer', textAlign: 'center' },
  resetBtn2: { marginTop: 8, padding: '8px 16px', border: '1px solid #ddd', borderRadius: 8, background: '#fff', color: '#666', fontSize: 12, cursor: 'pointer' },
  statsBar: { display: 'flex', gap: 6, padding: '10px 12px', background: '#fff', borderBottom: '1px solid #eee' },
  statPill: { flex: 1, borderRadius: 10, padding: '8px 6px', textAlign: 'center' },
  listWrap: { flex: 1, overflowY: 'auto', padding: '8px 12px', display: 'flex', flexDirection: 'column', gap: 8 },
  empty: { textAlign: 'center', color: '#888', padding: '3rem 1rem', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 },
  actionCard: { background: '#fff', borderRadius: 10, padding: '12px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' },
  actionHeader: { display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 8 },
  actionTitre: { fontSize: 13, fontWeight: 600, color: COULEUR },
  actionClient: { fontSize: 12, color: '#888', marginTop: 2 },
  statutBadge: { fontSize: 10, padding: '3px 8px', borderRadius: 99, fontWeight: 600, flexShrink: 0 },
  actionMeta: { display: 'flex', gap: 8, flexWrap: 'wrap' },
  metaItem: { fontSize: 11, color: '#888' },
  commentaire: { fontSize: 12, color: '#555', background: '#f9f9f9', borderRadius: 8, padding: '6px 10px', marginTop: 8, fontStyle: 'italic' },
};
